import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';

import { Alert } from '../../../common/util/Alert';
import { ShipmentManifestASN } from "../../../common/model/ShipmentManifestASN";
import { ShipmentASNFacade as ShipmentAsnService } from "../../../common/facade/ShipmentASN.service";
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { TableMessages } from '../../../common/util/TableMessages';

@Component({
  selector: 'app-shipments-asn-detail',
  templateUrl: './shipments-asn-detail.component.html',
  styleUrls: ['./shipments-asn-detail.component.css']
})
export class shipmentsAsnDetailComponent implements OnInit {
    private readonly USE_MOCK_DATA = false;
    private readonly organizationUSA = 'US30';
    path = 'inventory/shipments-asn';
    
    loading = false;
    messageLoader = '';
    isSpanish = true;
    shipmentAsnCode: string = '';
    manifest = '';
    
    extras: NavigationExtras = {};

    rows: ShipmentManifestASN[] = [];
    alerts: Alert[] = [];

    //Strings
    lblStyles = res.styles
    titleDelivery = res.Delivery;
    lblDeliveryCode = res.Delivery;
    lblAsnCodes = res.ASNCode;
    lblCartonCode = res.CartonCode;
    lblManifestNumber = res.ShippingNumber;
    lblParcelGuide = res.Guide;
    lblInvoice = res.Invoice;
    lblDownload = res.Download;
    lblSearch = res.Search;
    lblGuideNumber = res.GuideNumber;
    lblQuantity = res.Quantity;
    lblStatus = res.Status;
    lblReceived = res.Received;
    lblPending = res.PendingRet;
    lblManifest = res.Manifest;
    lblReceptionDate = res.ReceptionDate;

    messagesTable: TableMessages = {
        emptyMessage: '',
        totalMessage: ''
    };


    private _filteredData: ShipmentManifestASN[] = [];
    private _storeId = -1;
    private _startDate: string;
    private _endDate: string;
    private _organizationId = null;
 

    // Constructor
    constructor( 
        private _service: ShipmentAsnService
        , private _router: Router
        , private _route: ActivatedRoute
        , private _activatedRoute: ActivatedRoute
        , private _excel: ExcelUtility
        , private _datePipe: DatePipe
        , public strings: Strings
    ){}

    ngOnInit(): void {
        this.loading = true;

        this.isSpanish = this.strings.getLanguageIsSpanish();

        this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
        this.messagesTable.totalMessage = this.strings.GetText(res.Total);

        this.shipmentAsnCode = this._activatedRoute.snapshot.paramMap.get('code');
        
        let language = 0;
        if (!this.isSpanish) {
            language = 1;
        }        

        const queryParams = this._activatedRoute.snapshot.queryParams;
        this._storeId = Number(queryParams['storeid']);
        this._startDate = queryParams['startDate'];
        this._endDate = queryParams['endDate'];
        this._organizationId = queryParams['organizationid'];

        this.extras = {
            queryParams: {
                startDate: this._startDate,
                endDate: this._endDate,
                storeid: this._storeId,
                organizationid: this._organizationId,
                shipmentAsnCode: this.shipmentAsnCode
            }
        };

        this.loadDataFromService();
        
    }

    private loadDataFromService(): void {
        this._service.GetByCode(this.shipmentAsnCode).subscribe(
            result => {
                if (result.completed && result.data) {       
                    this.manifest = result.data.manifest || '';             
                    this.rows = result.data.asnManifestDetail || [];
                    console.log(this.rows)
                    this._filteredData = result.data.asnManifestDetail || [];
                    this.loading = false;
                } else {
                    this.addAlert('<strong>' + result.message + '</strong>', 'danger');
                    this.loading = false;
                }
            },
            error => {
                this.addAlert('<strong>Error: ' + error + '</strong>', 'danger');
                this.loading = false;
            }
        );
    }
    
    // añadir alert
    addAlert(message: string, type: string): void {
        this.alerts = [];
        this.alerts.push({ type, msg: message });
    }

      // cerrar alert
    onClosed(dismissedAlert: Alert) {
        this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
    }

    updateFilter(event: KeyboardEvent): void {
        const val = (event.target as HTMLInputElement).value.toLowerCase();
        
        if (!val) {
            this.rows = [...this._filteredData];
            return;
        }

        if (this._filteredData.length === 0) {
            this.rows = [];
            return;
        }

        this.rows = this._filteredData.filter(item => {
            const keys = Object.keys(item);
            
            return keys.some(key => {
                const value = item[key];
                return value !== null && 
                       value !== undefined && 
                       value.toString().toLowerCase().includes(val);
            });
        });
    }

    downloadLayout(): void {
        if (this.rows.length > 0) {
            const data: any = [];
            
            this.rows.forEach(row => {
                const isMinDate = !row.receptionDate || new Date(row.receptionDate).getFullYear() <= 1900;
                const info = {
                    [this.strings.GetText(res.CartonCode)]: row.cartonCode,
                    [this.strings.GetText(res.Delivery)]: row.deliveryCode,
                    [this.strings.GetText(res.ShippingNumber)]: row.manifestNumber,
                    [this.strings.GetText(res.Guide)]: row.parcelGuide,
                    [this.strings.GetText(res.Status)]: 
                        row.PackageReceptionDetId > 0 ? 
                            this.strings.GetText(res.Received) : this.strings.GetText(res.PendingRet),
                    [this.strings.GetText(res.ReceivedDate)]: isMinDate ? '' :
                        this.isSpanish
                        ? this._datePipe.transform(row.receptionDate, 'dd/MM/yy')
                            : this._datePipe.transform(row.receptionDate, 'MM/dd/yy'),
                };
                data.push(info);
            });
            this._excel.exportAsExcelFile(data, this.strings.GetText(res.ShipmentASNDetail));
        } else {
            this.addAlert(this.strings.GetText(res.AlertSelectActivityFirst), 'danger');
        }
    }

    onViewStylesASNDetail(id: number, deliveryCode: string): void {
        const navigationExtras: NavigationExtras = {
            queryParams: {
                startDate: this._startDate,
                endDate: this._endDate,
                storeid: this._storeId,
                organizationid: this._organizationId,
                deliveryCode: deliveryCode
            }
        };
        console.log(id)
        console.log(deliveryCode)
        this._router.navigate(['/inventory/shipments-asn-variety-detail', id], navigationExtras)
        .then((e) => { });
    }
}